import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {formatErrors} from 'actions/errors';

const checkAuthentication = (props, context) => {
    if (props.isAuthenticated) {
        context.router.history.push('/');
    }
};

export default (Component) => {
    class NotAuthenticate extends React.Component {
        static propTypes = {
            isAuthenticated: PropTypes.bool.isRequired,
            formatErrors: PropTypes.func.isRequired,
        };
        static contextTypes = {
            router: PropTypes.object.isRequired,
        };

        componentDidMount() {
            checkAuthentication(this.props, this.context);
        }

        componentDidUpdate() {
            checkAuthentication(this.props, this.context);
        }

        render() {
            return (
                <Component {...this.props} />
            );
        }
    }

    return connect(
        (state) => ({
            isAuthenticated: state.account.isAuthenticated,
        }),
        {formatErrors}
    )(NotAuthenticate);
};
